<template>
  <a
    :href="url"
    target="_blank"
    class="list-group-item list-group-item-action"
  >{{ name }}</a>
</template>

<script>
export default {
  name: "ServiceItem",
  props: {
    serviceName: {
      type: String,
      default: ""
    },
    serviceUrl: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
        name: this.serviceName,
        url: this.serviceUrl
    };
  }
};
</script>